<template>
  <JadePopover
    v-bind="$props"
    :open="open"
    :z-index="900"
    :allowed-placements="allowedPlacements"
    :offset="offset"
    @toggleOpen="toggleOpen"
    @closePopover="closePopover"
  >
    <template #trigger>
      <slot name="trigger" />
    </template>
    <div class="jade-dropdown">
      <div class="jade-dropdown__content">
        <template>
          <slot />
        </template>
      </div>
    </div>
  </JadePopover>
</template>

<script>
import JadePopover from '@jade/JadePopover'

export default {
  name: 'JadeDropdown',
  components: { JadePopover },
  props: {
    open: Boolean,
    allowedPlacements: Array,
    alignment: String,
    offset: {
      type: Number,
      default: 5
    }
  },
  methods: {
    toggleOpen (value) {
      this.$emit('toggleOpen', !!value)
    },
    closePopover () {
      this.$emit('closePopover')
    }
  }
}
</script>

<style scoped>
@import '@stone-payments/jade/css/dropdown.css';
</style>
